{
  "appName": "Transfers",
  "actions": {
    "add": "Add",
    "create": "Create",
    "edit": "Edit",
    "view": "View",
    "viewDetails": "View Details",
    "delete": "Delete",
    "save": "Save",
    "saveChanges": "Save Changes",
    "saving": "Saving...",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "close": "Close",
    "back": "Back",
    "search": "Search",
    "searchPlaceholder": "Search...",
    "filters": "Filters",
    "applyFilters": "Apply Filters",
    "resetFilters": "Reset Filters",
    "exportToExcel": "Export to Excel",
    "exporting": "Exporting...",
    "print": "Print",
    "refresh": "Refresh",
    "retry": "Retry",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "changeStatus": "Change Status",
    "restore": "Restore",
    "copy": "Copy",
    "copied": "Copied"
  },
  "fields": {
    "actions": "Actions",
    "status": "Status",
    "fromDate": "From Date",
    "toDate": "To Date",
    "name": "Name",
    "phone": "Phone",
    "email": "Email",
    "address": "Address",
    "code": "Code",
    "branch": "Branch",
    "branches": "Branches",
    "createdAt": "Created At",
    "createdBy": "Created By",
    "updatedAt": "Updated At",
    "updatedBy": "Updated By"
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive",
    "deleted": "Deleted",
    "pending": "Pending"
  },
  "systems": {
    "CURRENCY": "Currency",
    "POS": "POS",
    "FUEL": "Fuel"
  },
  "yesNo": {
    "yes": "Yes",
    "no": "No"
  },
  "state": {
    "loading": "Loading",
    "noResults": "No results.",
    "noData": "No data available",
    "tryAdjustingFilters": "Try adjusting your filters to see more results",
    "error": "Could not load the data. Try again."
  },
  "table": {
    "rowsPerPage": "Rows per page",
    "showing": "Showing {{start}}-{{end}} of {{total}}",
    "clearFilter": "Clear filter: {{label}}",
    "sortBy": "Sort by {{column}}"
  },
  "pagination": {
    "previous": "Previous",
    "next": "Next",
    "label": "Pagination",
    "goToPrevious": "Go to previous page",
    "goToNext": "Go to next page",
    "morePages": "More pages"
  },
  "form": {
    "requiredFieldsNote": "Required fields are marked with an asterisk",
    "required": "This field is required",
    "maxLength": "Cannot exceed {{max}} characters",
    "minLength": "Must be at least {{min}} characters",
    "invalidFormat": "Invalid format",
    "discardChanges": "Discard changes?",
    "discardChangesDescription": "Your unsaved changes will be lost.",
    "discard": "Discard",
    "keepEditing": "Continue Editing"
  },
  "dialog": {
    "deleteConfirmation": "Delete Confirmation",
    "areYouSure": "Are you absolutely sure?"
  },
  "accessDenied": {
    "title": "Access Denied",
    "description": "You don't have permission to view this page"
  },
  "language": {
    "label": "Language",
    "ar": "Arabic",
    "en": "English",
    "switchTo": {
      "ar": "Switch to Arabic",
      "en": "Switch to English"
    },
    "short": {
      "ar": "عربي",
      "en": "EN"
    }
  },
  "theme": {
    "switchToLight": "Switch to light mode",
    "switchToDark": "Switch to dark mode"
  },
  "notFound": {
    "title": "Page not found",
    "description": "The page you are looking for does not exist or has moved.",
    "action": "Back to home"
  },
  "combobox": {
    "placeholder": "Select...",
    "search": "Search...",
    "empty": "No results",
    "clearOption": "None",
    "clearSelection": "Clear selection",
    "removeSelection": "Remove {{label}}",
    "selectedCount_one": "{{count}} selected",
    "selectedCount_two": "{{count}} selected",
    "selectedCount_few": "{{count}} selected",
    "selectedCount_many": "{{count}} selected",
    "selectedCount_other": "{{count}} selected"
  },
  "filterToolbar": {
    "phoneCountryCode": "Country code",
    "toggle": "Filters",
    "resetFilters": "Reset filters"
  },
  "breadcrumb": {
    "label": "Breadcrumb",
    "more": "More"
  },
  "selection": {
    "selectRow": "Select row",
    "thisPage": "This page",
    "allMatching": "All {{count}} matching"
  },
  "toaster": {
    "label": "Notifications"
  }
}
